import { simplebar } from './modules/simplebar';
import { accordion } from './modules/accordion';
import { hamburger } from './modules/hamburger';
import { smooth } from './modules/smooth';
import { scrollmagic } from './modules/scrollmagic';

document.addEventListener("DOMContentLoaded", () => {
  simplebar();
  accordion();
  hamburger();
  smooth();
});

window.addEventListener('load', () => {
  scrollmagic();
})